import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function shouldAutoAddSignature(operation) {
    var userOptions = getUserConfiguration().UserOptions;
    var autoAddSignature = false;
    switch (operation) {
        case 0 /* New */:
            autoAddSignature = userOptions.AutoAddSignature;
            break;
        case 1 /* Reply */:
        case 2 /* ReplyAll */:
        case 3 /* Forward */:
            autoAddSignature = userOptions.AutoAddSignatureOnReply;
            break;
    }
    return autoAddSignature;
}
//# sourceMappingURL=shouldAutoAddSignature.js.map